<template>
  <div
      class="pag-list-card pag-body-text-sm"
      v-if="initializedStatus"
  >
    <template v-if="session">
      <div
          :class="[session.IsPoster ? 'poster__card': 'session__card']"
          :style="`
          border-left: ${`solid 6px ${sessionCardColor === 'SessionGroups' ? (session.SessionGroups && session.SessionGroups.length > 0 ? session[sessionCardColor][0].Color : '#000') : session[sessionCardColor]}`};
          background-color: ${`${hexToRgbA(sessionCardColor === 'SessionGroups' ? (session.SessionGroups && session.SessionGroups.length > 0 ? session[sessionCardColor][0].Color : '#000') : session[sessionCardColor])}`};
        `"
          @click="goToProgramme(session.SessionId, 'SessionStart', session)"
      >
        <template v-if="!session.IsPoster">
          <div
              class="__card-content"
              :class="session.SessionTypeName ? session.SessionTypeName.split(' ').join('_') : ''"
          >
            <div
                v-if="isChair"
                class="__chair-information"
            >
              {{ `${$te("VMX.isChairInformation") ? $t("VMX.isChairInformation") : 'You are a chair of this session' }` }}
            </div>
            <div :class="['__card-content-child', sessionListView ? 'single' : '']">
              <div v-if="session.SessionTypeGrade === 'Industry' && checkIfIndustrySymposia() && showThumbnailOnIndustrySymposia" class="__symposia-thumbnail-container">         
                <img class="__symposia-thumbnail-image" :src="industryThumnailSrc">
              </div>
              <div class="__card-session-info-left">
                <div :class="{ condensed: enableCondensedCards }">
                <div
                    class="__session-number"
                    v-if="showSessionShortInsteadOfId && session.Short"
                  >
                    <span
                      v-html="`${session.Short}`"
                    />
                  </div>
                  <div
                    class="__session-number"
                    v-else-if="cardProps.cardConfig.sessionCard.showId && session.SessionNumber"
                  >
                    <span
                    v-html="`${$t('VMX.my_programme_session_id')+' ' + session.SessionNumber}`"
                    />
                  </div>
                </div>
                <div
                    class="__session-room"
                    v-if="cardProps.cardConfig.sessionCard.showRoom && session.RoomName"
                >
                  <span class="__session-room-svg">
                    <font-awesome-icon :icon="['fas', 'map-marker']" />
                  </span>

                  <span>
                    {{ session.RoomName }}
                  </span>
                </div>
                <div
                    class="__session-name pag-body-text"
                    v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.sessionCard && cardProps.cardConfig.sessionCard.showTitle && session.TextWithFormat"
                    v-html="checkIfIndustrySymposia() ? session.TextWithFormat : changeSessionLabel(session)"
                />
                <div :class="{ condensed: enableCondensedCards }">
                <div
                    class="__session-type"
                    v-if="cardProps.cardConfig.sessionCard.showSessionTypeName && session.SessionTypeName"
                >
                  <span
                      v-html="session.SessionTypeName"
                  />
                </div>
              </div>
                
                <div
                    class="__session-groups"
                    v-if="cardProps.cardConfig.sessionCard.showSessionGroup && session.SessionGroups && sessionGroup"
                >
                  <span
                      class="__tags pag-default-btn-inverse-sm"
                      v-for="(group, idx) in sessionGroup"
                      :key="`${group}-${idx}`"
                      v-html="group"
                  />
                </div>
                <div :class="{ condensed: enableCondensedCards }">
                <div
                    class="__session-tags"
                    v-if="cardProps.cardConfig.sessionCard.showSessionTags && session.SessionTags"
                >
                  <span
                      class="__tags pag-default-btn-inverse-sm"
                      v-for="(tags, idx) in session.SessionTags"
                      :key="`${tags}-${idx}`"
                      v-html="tags"
                  />
                </div>
              </div>

              </div>
              <div :class="['__card-session-info-right', sessionListView ? 'single' : '']">
                <div :class="['__top-right-container', sessionListView ? 'single' : '', { condensed: enableCondensedCards }]">
                  <template v-if="cardProps.cardConfig.sessionCard.showCountdown && countdown && session.IsLiveSession">
                    <span class="__card-cd-live-indicator">
                      <template v-if="countdown === 'LIVE'">
                        <font-awesome-icon :icon="['fas', 'circle']" />
                      </template>
                      <template v-else>
                        <font-awesome-icon :icon="['fas', 'clock']" />
                      </template>
                      {{ countdown }}
                    </span>
                  </template>
                  <template v-if="!session.IsLiveSession">
                    <div
                    :class="['__card-time-display', sessionListView ? 'single' : '', { condensed: enableCondensedCards }]"
                    v-if="cardProps.cardConfig.sessionCard.showTime"
                    >
                      <span>
                        {{ `${formatOndemandDate(session.StartDateTime)}` }}
                      </span>
                      <span>
                        {{ `${ formatTimeSession(session.StartDateTime, session.EndDateTime) } ${ timeZoneName(session.StartDateTime)}` }}
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <div
                    :class="['__card-time-display', sessionListView ? 'single' : '', { condensed: enableCondensedCards }]"
                    v-if="cardProps.cardConfig.sessionCard.showTime"
                    >
                      <span>
                        {{ `${formatOndemandDate(session.StartDateTime)}` }}
                      </span>
                      <span>
                        {{ `${ formatTimeSession(session.StartDateTime, session.EndDateTime) } ${ timeZoneName(session.StartDateTime)}` }}
                      </span>
                    </div>
                  </template>
                </div>
                <div :class="['__bottom-right-container', sessionListView ? 'single' : '']">
                  <template v-if="session.IsLiveSession">
                    <div
                        class="pag-scheduler__session-infos-live"
                        ref="session-infos-live"
                    >
                      <template v-if="cardProps.cardConfig.sessionCard.showIconsOnly">
                        <span
                            class="pag-scheduler__session-infos-live-icon"
                        >
                          <font-awesome-icon :icon="['fas', 'wifi']" />
                        </span>
                      </template>
                      <template v-else>
                        <span class="pag-scheduler__session-infos-live-text">{{ $t('PAG.session_info_live') }}</span>
                      </template>
                    </div>
                  </template>
                  <template v-if="session.IsOnDemandSession">
                    <div
                        class="pag-scheduler__session-infos-ondemand"
                        ref="session-infos-ondemand"
                    >
                      <template v-if="cardProps.cardConfig.sessionCard.showIconsOnly">
                        <span
                            class="pag-scheduler__session-infos-ondemand-icon"
                        >
                          <font-awesome-icon :icon="['fas', 'circle-play']" />
                        </span>
                      </template>
                      <template v-else>
                        <span class="pag-scheduler__session-infos-ondemand-text">{{ $t('PAG.session_info_ondemand') }}</span>
                      </template>
                    </div>
                  </template>
                  <template v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.sessionCard && cardProps.cardConfig.sessionCard.showSessionHighlight && session.Highlight">
                    <div
                        class="pag-scheduler__session-infos-highlight"
                        ref="session-infos-highlight"
                    >
                      <span>{{ $t("VMX.Highlight_lbl") }}</span>
                    </div>
                  </template>
                  <div
                      class="__card-views"
                      v-if="cardProps.cardConfig.sessionCard.showViews && session.EnableViewCounter"
                  >
                    <font-awesome-icon :icon="['fas', 'eye']" />&nbsp;
                    <span>{{ session.SessionViewCount }}</span>
                  </div>
                  <div
                      class="__card-rating"
                      v-if="cardProps.cardConfig.sessionCard.showRating && session.EnableRating && user"
                  >
                    <rating
                        :id="session.SessionId.toString()"
                        :myrating="myRating ? myRating : session.RatingAvg"
                        :readonly="false"
                        :size="20"
                        :active-color="activeColor"
                        :inactive-color="inactiveColor"
                        rating-context="Session"
                    />
                  </div>
                </div>
                <div :class="['__card-content-child-actions', sessionListView ? 'single' : '']">
                  <div :class="['__card-session-actions', sessionListView ? 'single' : '', { condensed: enableCondensedCards }]">
                    <template v-if="!isChair && (user || enableLoginModal )">
                        <button
                            class="__add-to-favourite pag-default-btn-inverse-sm"
                            v-if="cardProps.cardConfig.sessionCard.showFavoritesToggle"
                            @click.stop="
                            user ? 
                            toggleFavorites(
                              session.SessionId,
                              'SessionStart',
                              session.IsPoster
                            )
                            : showLoginModal()
                          "
                        >
                          <template v-if="isFavorite(session.SessionId, 'SessionStart')">
                            <font-awesome-icon :icon="['fas', 'star']" />
                            <span>{{ $t("VMX.my_programme_remove_from_favourites") }}</span>
                          </template>
                          <template v-else>
                            <font-awesome-icon :icon="['far', 'star']" />
                            <span>{{ $t("VMX.my_programme_add_to_favourites") }}</span>
                          </template>
                        </button>
                      </template>
                      <button
                          class="__download-calendar pag-default-btn-inverse-sm"
                          v-if="cardProps.cardConfig.sessionCard.showCalendarDownload"
                          @click.stop="
                          downloadCal(session.SessionId, 'SessionStart', session.IsPoster, session)
                        "
                      >
                        <font-awesome-icon :icon="['fas', 'calendar']" />
                        <span>{{ $t("VMX.my_programme_save_calender") }}</span>
                      </button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="__card-content">
            <div
                v-if="isChair"
                class="__chair-information"
            >
              {{ `${$te("VMX.isChairInformation") ? $t("VMX.isChairInformation") : 'You are a chair of this session' }` }}
            </div>
            <div :class="['__card-content-child', posterListView ? 'single' : '']">
              <div class="__card-session-info-left">
                <div :class="{ condensed: enableCondensedCards }">
                <div
                    class="__session-number"
                    v-if="cardProps.cardConfig.posterCard.showId && session.SessionNumber"
                >
                  <span
                      v-html="`${$t('VMX.my_programme_poster_id')+' ' + session.SessionNumber}`"
                  />
                </div>
              </div>
                <div
                    class="__session-room"
                    v-if="cardProps.cardConfig.posterCard.showRoom && session.RoomName"
                >
                  <span class="__session-room-svg">
                    <font-awesome-icon :icon="['fas', 'map-marker']" />
                  </span>

                  <span>
                    {{ session.RoomName }}
                  </span>
                </div>
                <div
                    class="__session-name pag-body-text"
                    v-if="cardProps.cardConfig.posterCard.showTitle && session.TextWithFormat"
                    v-html="checkIfIndustrySymposia() ? session.TextWithFormat : changeSessionLabel(session)"
                />
                <div :class="{ condensed: enableCondensedCards }">
                <div
                    class="__session-type"
                    v-if="cardProps.cardConfig.posterCard.showSessionTypeName && session.SessionTypeName"
                >
                  <span
                      v-html="session.SessionTypeName"
                  />
                </div>
              </div>
                <div
                    class="__session-groups"
                    v-if="cardProps.cardConfig.posterCard.showSessionGroup && session.SessionGroups && sessionGroup"
                >
                  <span
                      class="__tags pag-default-btn-inverse-sm"
                      v-for="(group, idx) in sessionGroup"
                      :key="idx"
                      v-html="group"
                  />
                </div>
                <div :class="{ condensed: enableCondensedCards }">
                <div
                    class="__session-tags"
                    v-if="cardProps.cardConfig.posterCard.showSessionTags && session.SessionTags"
                >
                  <span
                      class="__tags pag-default-btn-inverse-sm"
                      v-for="(tags, idx) in session.SessionTags"
                      :key="`${tags}-${idx}`"
                      v-html="tags"
                  />
                </div>
              </div>
              </div>
              <div :class="['__card-session-info-right', posterListView ? 'single' : '']">
                <div :class="['__top-right-container', posterListView ? 'single' : '', { condensed: enableCondensedCards }]">
                  <template v-if="cardProps.cardConfig.posterCard.showCountdown && countdown && session.IsLiveSession">
                    <span class="__card-cd-live-indicator">
                      <template v-if="countdown === 'LIVE'">
                        <font-awesome-icon :icon="['fas', 'circle']" />
                      </template>
                      <template v-else>
                        <font-awesome-icon :icon="['fas', 'clock']" />
                      </template>
                      {{ countdown }}
                    </span>
                  </template>
                  <template v-if="!session.IsLiveSession">
                    <div
                    :class="['__card-time-display', posterListView ? 'single' : '', { condensed: enableCondensedCards }]"
                        v-if="cardProps.cardConfig.posterCard.showTime && session.StartDateTime"
                    >
                      <span>
                        {{ `${formatOndemandDate(session.StartDateTime)}` }}
                      </span>
                      <span>
                        {{ `${ formatOndemandTime(session.StartDateTime)} ${timeZoneName(session.StartDateTime)}` }}
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <div
                    :class="['__card-time-display', posterListView ? 'single' : '', { condensed: enableCondensedCards }]"
                        v-if="cardProps.cardConfig.posterCard.showTime && session.StartDateTime && session.EndDateTime"
                    >
                      <span>
                        {{ `${formatDateTime(session.StartDateTime)}` }}
                      </span>
                      <span>
                        {{ `${ formatTimeSession(session.StartDateTime, session.EndDateTime) } ${ timeZoneName(session.StartDateTime)}` }}
                      </span>
                    </div>
                  </template>
                </div>
                <div :class="['__bottom-right-container', posterListView ? 'single' : '']"
                >
                  <template v-if="session.IsLiveSession">
                    <div
                        class="pag-scheduler__session-infos-live"
                        ref="session-infos-live"
                    >
                      <template v-if="cardProps.cardConfig.posterCard.showIconsOnly">
                        <span
                            class="pag-scheduler__session-infos-live-icon"
                        >
                          <font-awesome-icon :icon="['fas', 'wifi']" />
                        </span>
                      </template>
                      <template v-else>
                        <span class="pag-scheduler__session-infos-live-text">{{ $t('PAG.session_info_live') }}</span>
                      </template>
                    </div>
                  </template>
                  <template v-if="session.IsOnDemandSession">
                    <div
                        class="pag-scheduler__session-infos-ondemand"
                        ref="session-infos-ondemand"
                    >
                      <template v-if="cardProps.cardConfig.posterCard.showIconsOnly">
                        <span
                            class="pag-scheduler__session-infos-ondemand-icon"
                        >
                          <font-awesome-icon :icon="['fas', 'circle-play']" />
                        </span>
                      </template>
                      <template v-else>
                        <span class="pag-scheduler__session-infos-ondemand-text">{{ $t('PAG.session_info_ondemand') }}</span>
                      </template>
                    </div>
                  </template>
                  <template v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.sessionCard && cardProps.cardConfig.sessionCard.showSessionHighlight && session.Highlight">
                    <div
                        class="pag-scheduler__session-infos-highlight"
                        ref="session-infos-highlight"
                    >
                      <span>{{ $t("VMX.Highlight_lbl") }}</span>
                    </div>
                  </template>
                  <div
                      class="__card-views"
                      v-if="cardProps.cardConfig.posterCard.showViews && session.EnableViewCounter"
                  >
                    <font-awesome-icon :icon="['fas', 'eye']" />&nbsp;
                    <span>{{ session.SessionViewCount }}</span>
                  </div>
                  <div
                      class="__card-rating"
                      v-if="cardProps.cardConfig.posterCard.showRating && session.EnableRating && (user || enableLoginModal)"
                      @click="!user ? showLoginModal() : null"
                  >
                    <rating
                        :id="session.SessionId.toString()"
                        :myrating="myRating ? myRating : session.RatingAvg"
                        :readonly="false"
                        :size="20"
                        :active-color="activeColor"
                        :inactive-color="inactiveColor"
                        rating-context="Session"
                    />
                  </div>
                </div>
                <div :class="['__card-content-child-actions', posterListView ? 'single' : '']">
                  <div :class="['__card-session-actions', posterListView ? 'single' : '', { condensed: enableCondensedCards }]">
                    <template v-if="!isChair && (user || enableLoginModal)">
                      <button
                          class="__add-to-favourite pag-default-btn-inverse-sm"
                          v-if="cardProps.cardConfig.posterCard.showFavoritesToggle"
                          @click.stop="
                            user ? 
                            toggleFavorites(
                              session.SessionId,
                              'SessionStart',
                              session.IsPoster
                            )
                            : showLoginModal()
                          "
                      >
                        <template v-if="isFavorite(session.SessionId, 'SessionStart')">
                          <font-awesome-icon :icon="['fas', 'star']" />
                          <span>{{ $t("VMX.my_programme_remove_from_favourites") }}</span>
                        </template>
                        <template v-else>
                          <font-awesome-icon :icon="['far', 'star']" />
                          <span>{{ $t("VMX.my_programme_add_to_favourites") }}</span>

                        </template>
                      </button>
                    </template>
                    <button
                        class="__download-calendar pag-default-btn-inverse-sm"
                        v-if="cardProps.cardConfig.posterCard.showCalendarDownload"
                        @click.stop="
                        downloadCal(session.SessionId, 'SessionStart', session.IsPoster,session)
                      "
                    >
                      <font-awesome-icon :icon="['fas', 'calendar']" />
                      <span>{{ $t("VMX.my_programme_save_calender") }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-if="presentation">
      <div
          :class="[presentation.IsPoster ? 'poster-presentation__card': 'presentation__card']"
          @click="openAbstractsInsteadOfPresentations ? downloadAbstract(assignedAbstract.HtmlFileUrl || assignedAbstract.PdfFileUrl, assignedAbstract.Id) : goToProgramme(presentation.PresentationId, 'Presentation', null, presentation)"
                    :style="`
          background-color: ${`${hexToRgbA(presentationCardColor === 'SessionGroups' ? (presentation.SessionGroups && presentation.SessionGroups.length > 0 ? presentation[presentationCardColor][0].Color : '#000'): presentation[presentationCardColor] )}`};
        `"
      >
        <template v-if="!presentation.IsPoster">
          <div class="__card_content">
            <div
                v-if="isSpeaker"
                class="__speaker-information"
            >
              {{ `${$te("VMX.isSpeakerInformation") ? $t("VMX.isSpeakerInformation") : 'You are a speaker of this session' }` }}
            </div>
            <div :class="['__card-content-child', presentationListView ? 'single' : '']">
              <div :class="[presentationListView ? 'single' : '', '__card-presentation-info-left']">
                <b-img
                  v-if="showAuthorImageInList"
                  :src="author && author[0] ? author[0].ProfileUrl : `${defaultProfileError}`"
                  @error="$event.target.src=`${defaultProfileError}`"
                  :class="['__content-profile-image']"
                />
                <b-img
                    v-else-if="initializedStatus && cardProps.cardConfig.presentationCard.showWebcastImage && thumbnailSrc && !hideThumbnailInStandalone"
                    :src="thumbnailSrc"
                    @error="$event.target.src=`${defaultThumbnailError}`"
                    :class="['__card_thumbnail']"
                />
                <!-- <b-img
                  v-else-if="noWebcastPlaceHolder"
                  src="template.noWebcastPreviewThumbnail"
                  class="my-programme__card__thumbnail"
                  fluid
                /> -->
                <!-- <b-img
                  v-else-if="cardProps.cardConfig.presentationCard.showWebcastImage && !presentation.Thumbnail || presentation.Thumbnail ==''"
                  src="https://m-obile.com/temp/video-placeholder.jpg"
                  class="my-programme__card__thumbnail"
                  fluid
                /> -->
              </div>
              <div :class="[presentationListView ? 'single' : '', '__card-presentation-info-right']">
                <div class="__card-presentation-left-side">
                  <div
                      class="__presentation-number"
                      v-if="cardProps.cardConfig.presentationCard.showId && presentation.Number"
                  >
                    <span
                        v-html="`${$t('VMX.my_programme_presentation_id')+' ' + presentation.Number}`"
                    />
                  </div>
                  <div
                      class="__presentation-room"
                      v-if="cardProps.cardConfig.presentationCard.showRoom && presentation.RoomName"
                  >
                    <span class="__session-room-svg">
                      <font-awesome-icon :icon="['fas', 'map-marker']" />
                    </span>
                    <span>
                      {{ presentation.RoomName }}
                    </span>
                  </div>
                  <div
                      class="__presentation-name pag-body-text"
                      v-if="cardProps.cardConfig.presentationCard.showTitle && (presentation.TextWithFormat || presentation.Text)"
                      v-html="presentation.TextWithFormat || presentation.Text"
                  />
                  <div
                      class="__presentation-highlight"
                      v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.presentationCard && cardProps.cardConfig.presentationCard.showPresentationHighlight && presentation.Highlight"
                  >
                    <span>{{ $t("VMX.Highlight_lbl") }}</span>
                  </div>
                  <template v-if="cardProps.cardConfig.presentationCard.showAuthors">
                    <div>
                      <div
                          class="__presentation-speaker"
                          v-for="(speaker, key) in authors"
                          :key="key"
                      >
<span
  class="__presentation-speaker-name"
  v-html="
    enableDisplayNameWithInitials
      ? (speaker.Title
          ? `${capitalizeEveryWord(speaker.Firstname)} ${capitalizeEveryWord(speaker.Surname)}, ${speaker.Title}`
          : `${capitalizeEveryWord(speaker.Firstname)} ${capitalizeEveryWord(speaker.Surname)}`)
      : (titleCondition
          ? `${speaker.Title} ${capitalizeEveryWord(speaker.Firstname)} ${capitalizeEveryWord(speaker.Surname)}`
          : `${capitalizeEveryWord(speaker.Firstname)} ${capitalizeEveryWord(speaker.Surname)}`)
  "
/>
<span
                          v-if="showAuthorTitleProfession"
                          class="presentation-info-box__detail--speaker-profession">
                          {{ `${speaker.Title ? speaker.Title : ''}` }}
                      </span><span class="__presentation-speaker-institute" v-if="speaker.Institute && cardProps.cardConfig.presentationCard.showAuthorInstitute">
                        {{speaker.Institute}}</span><span
                            class="__presentation-speaker-city"
                            v-if="cardProps.cardConfig.presentationCard.showAuthorCity
                              && (speaker?.City?.toLowerCase() !== 'all')
                            "
                            v-html="speaker.City ? ` ${openBracket}${speaker.City}${speaker.Country && cardProps.cardConfig.presentationCard.showAuthorCountry ? ', ': closeBracket}`:''"
                        /><span
                            class="__presentation-speaker-country"
                            v-if="cardProps.cardConfig.presentationCard.showAuthorCountry
                              && (speaker?.City?.toLowerCase() !== 'all')
                            "
                            v-html="speaker.Country ? `${speaker.City && cardProps.cardConfig.presentationCard.showAuthorCity ? '': ' '+openBracket}${speaker.Country}${closeBracket}`:''"
                        />
                        <span
                            class="presentation-card__speaker--hybridMode"
                            v-if="showHybridMode === true && presentation.HybridMode !== 'None'"
                        >{{ presentation.HybridMode }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <div
                    class="__presentation-name pag-body-text"
                    v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.presentationCard && cardProps.cardConfig.presentationCard.showSessionTitle && presentation.Text"
                    v-html="presentation.SessionTitle"
                  />
                  <div
                      class="__presentation-tags"
                      v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.presentationCard && cardProps.cardConfig.presentationCard.showPresentationTags && presentation.PresentationTags"
                  >
                    <span
                        class="__tags pag-default-btn-inverse-sm"
                        v-for="(tags, idx) in presentation.PresentationTags"
                        :key="idx"
                        v-html="tags"
                    />
                  </div>
                  <template v-if="cardProps.cardConfig.presentationCard.showKeywords && presentation.Keywords">
                    <div
                        class="__presentation-keywords"
                    >
                      <span
                          class="__tags pag-default-btn-inverse-sm"
                          v-for="(tag, key) in presentation.Keywords"
                          :key="key"
                      >
                        {{ tag }}
                      </span>
                    </div>
                  </template>
                </div>
                <div class="__card-presentation-right-side">
                  <div
                    v-if="contentList === 'Detail' && presentation.UseSessionRecordingV2 && content === 'Session' && showWatchNow(presentation.PresentationId)"
                    :class="[presentationListView ? '__session-recording-btn-container' : 'list__session-recording-btn-container']"
                  >
                    <button
                      class="__jump-to-presentation pag-default-btn"
                      @click.stop="jumpToSessionRecording()"
                    >
                      <font-awesome-icon :icon="['fas', 'play']" />
                      {{ $te("VMX.jump_to_presentation_btn") ? $t("VMX.jump_to_presentation_btn") : 'Watch now' }}
                    </button>
                  </div>
                  <template
                      v-if="
                      cardProps.cardConfig.presentationCard.showTime &&
                        (!presentation.IsLiveSession && !liveInformation)||
                        (liveInformation &&
                          !presentation.IsLiveSession &&
                          !liveInformation.IsLiveSession)
                    "
                  >
                    <div
                        :class="['__card-time-display', presentationListView ? 'single' : '']"
                        v-if="cardProps.cardConfig.presentationCard.showTime && presentation.OnDemandAvailability && showOnDemandTime"
                    >
                      <span>
                        {{ `${formatOndemandDate(presentation.OnDemandAvailability)}` }}
                      </span>
                      <span>
                        {{ `${ $t('AppTranslations.AvailableFrom') } ${ formatOndemandTimePresentation(presentation.OnDemandAvailability)} ${timeZoneName(presentation.StartDateTime)}` }}
                      </span>
                    </div>
                    <div
                        :class="['__card-time-display', presentationListView ? 'single' : '']"
                        v-else-if="cardProps.cardConfig.presentationCard.showTime && presentation.StartDateTime && presentation.EndDateTime"
                    >
                      <span>
                        {{ `${formatDateTime(presentation.StartDateTime)}` }}
                      </span>
                      <span>
                        {{ `${ formatTime(presentation.StartDateTime, presentation.EndDateTime) } ${ timeZoneName(presentation.StartDateTime)}` }}
                      </span>
                    </div>
                  </template>
                  <template v-else-if="cardProps.cardConfig.presentationCard.showTime && forceOndemandTime && presentation.OnDemandAvailability">
                    <div
                        :class="['__card-time-display', presentationListView ? 'single' : '']"
                   
                    >
                      <span>
                        {{ `${formatOndemandDate(presentation.OnDemandAvailability)}` }}
                      </span>
                      <span>
                        {{ `${ $t('AppTranslations.AvailableFrom') } ${ formatOndemandTimePresentation(presentation.OnDemandAvailability)} ${timeZoneName(presentation.StartDateTime)}` }}
                      </span>
                    </div>
                  </template>
                  <template v-else-if="cardProps.cardConfig.presentationCard.showTime">
                    <div
                        :class="['__card-time-display', presentationListView ? 'single' : '']"
                        v-if="cardProps.cardConfig.presentationCard.showTime && presentation.StartDateTime && presentation.EndDateTime"
                    >
                      <span>
                        {{ `${formatDateTime(presentation.StartDateTime)}` }}
                      </span>
                      <span>
                        {{ `${ formatTime(presentation.StartDateTime, presentation.EndDateTime) } ${ timeZoneName(presentation.StartDateTime)}` }}
                      </span>
                    </div>
                    <template v-if="false">
                      <span class="my-programme__card-countdown">
                        <template v-if="countdown === 'LIVE'">
                          <font-awesome-icon :icon="['fas', 'circle']" />
                        </template>
                        <template v-else>
                          <font-awesome-icon :icon="['fas', 'clock']" />
                        </template>
                        {{ countdown }}
                      </span>
                    </template>
                  </template>
                  <span
                      v-if="cardProps.cardConfig.presentationCard.showViews && presentation.EnableViewCounter"
                      :class="['__card-views', presentationListView ? 'single' : '']"
                      
                  >
                    <font-awesome-icon :icon="['fas', 'eye']" />
                    <span>{{ presentation.ViewCount }}
                      {{ $t("AppTranslations.ViewsLabel") }}</span>
                  </span>
                  <div
                      class="__card-rating"
                      v-if="cardProps.cardConfig.presentationCard.showRating && presentation.EnableRating && user"
                  >
                    <rating
                    :id="presentation.PresentationId.toString()"
                  :user-id="user ? user.UserId : null"
                  :myrating="myRatingPresentation ? myRatingPresentation : presentation.RatingAvg"
                  :readonly="false"
                  :size="20"
                  :active-color="activeColor"
                  :inactive-color="inactiveColor"
                  :border-color="activeColor"
                  rating-context="Presentation"
                />
                  </div>
                  <div :class="['__card-content-child-actions', presentationListView ? 'single' : '']">
                    <div :class="['__card-presentation-actions', presentationListView ? 'single' : '']">
                      <template v-if="!isSpeaker && (user || enableLoginModal)">
                        <button
                            class="__add-to-favourite pag-default-btn-inverse-sm"
                            v-if="cardProps.cardConfig.presentationCard.showFavoritesToggle"
                            @click.stop="
                            user ? 
                            toggleFavorites(
                              presentation.PresentationId,
                              'Presentation',
                              presentation.IsPoster
                            )
                            : showLoginModal()
                          "
                        >
                          <template
                              v-if="isFavorite(presentation.PresentationId, 'Presentation')"
                          >
                            <font-awesome-icon :icon="['fas', 'star']" />
                            {{ $t("VMX.my_programme_remove_from_favourites") }}
                          </template>
                          <template v-else>
                            <font-awesome-icon :icon="['far', 'star']" />
                            {{ $t("VMX.my_programme_add_to_favourites") }}
                          </template>
                        </button>
                      </template>
                      <button
                          class="__download-calendar pag-default-btn-inverse-sm"
                          v-if="cardProps.cardConfig.presentationCard.showCalendarDownload"
                          @click.stop="
                          downloadCal(
                            presentation.PresentationId,
                            'Presentation',
                            presentation.IsPoster,
                            presentation
                          )
                        "
                      >
                        <font-awesome-icon :icon="['fas', 'calendar']" />
                        {{ $t("VMX.my_programme_save_calender") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="__card_content">
            <div
                v-if="isSpeaker"
                class="__speaker-information"
            >
              {{ `${$te("VMX.isSpeakerInformation") ? $t("VMX.isSpeakerInformation") : 'You are a speaker of this session' }` }}
            </div>
            <div :class="['__card-content-child', posterPresentationListView ? 'single' : '']">
              <div :class="[posterPresentationListView ? 'single' : '', '__card-presentation-info-left']">
                <b-img
                  v-if="showAuthorImageInList"
                  :src="author && author[0] ? author[0].ProfileUrl : `${defaultProfileError}`"
                  @error="$event.target.src=`${defaultProfileError}`"
                  :class="['__content-profile-image']"
                />
               
                <b-img
                    v-else-if="initializedStatus && cardProps.cardConfig.posterPresentationCard.showWebcastImage && thumbnailSrc && !hideThumbnailInStandalone"
                    :src="thumbnailSrc"
                    @error="$event.target.src=`${defaultThumbnailError}`"
                    :class="['__card_thumbnail']"
                />
              </div>
              <div :class="[posterPresentationListView ? 'single' : '', '__card-presentation-info-right']">
                <div class="__card-presentation-left-side">
                  <div
                      class="__presentation-number"
                      v-if="cardProps.cardConfig.posterPresentationCard.showId && presentation.Number"
                  >
                    <span
                        v-html="`${$t('VMX.my_programme_poster_id')+' ' + presentation.Number}`"
                    />
                  </div>
                  <div
                      v-if="cardProps.cardConfig.posterPresentationCard.showRoom && presentation.RoomName"
                      class="__poster-room"
                  >
                    <span class="__session-room-svg">
                      <font-awesome-icon :icon="['fas', 'map-marker']" />
                    </span>
                    <span>
                      {{ presentation.RoomName }}
                    </span>
                  </div>
                  <div
                    class="__presentation-name pag-body-text"
                    v-if="cardProps.cardConfig.posterPresentationCard.showTitle && (presentation.TextWithFormat || presentation.Text)"
                    v-html="presentation.TextWithFormat || presentation.Text"
                />
                  <div
                      class="__presentation-highlight"
                      v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.posterPresentationCard && cardProps.cardConfig.posterPresentationCard.showPresentationHighlight && presentation.Highlight"
                  >
                    <span>{{ $t("VMX.Highlight_lbl") }}</span>
                  </div>
                  <template v-if="cardProps.cardConfig.posterPresentationCard.showAuthors">
                    <div>
                      <div
                          class="__presentation-speaker"
                          v-for="(speaker, key) in authors"
                          :key="key"
                      >
                      <span
  class="__presentation-speaker-name"
  v-html="
    enableDisplayNameWithInitials
      ? (speaker.Title
          ? `${capitalizeEveryWord(speaker.Firstname)} ${capitalizeEveryWord(speaker.Surname)}, ${speaker.Title}`
          : `${capitalizeEveryWord(speaker.Firstname)} ${capitalizeEveryWord(speaker.Surname)}`)
      : (titleCondition
          ? `${speaker.Title} ${capitalizeEveryWord(speaker.Firstname)} ${capitalizeEveryWord(speaker.Surname)}`
          : `${capitalizeEveryWord(speaker.Firstname)} ${capitalizeEveryWord(speaker.Surname)}`)
  "
/>
<span
                          v-if="showAuthorTitleProfession"
                          class="presentation-info-box__detail--speaker-profession">
                          {{ `${speaker.Title ? speaker.Title : ''}` }}
                        </span><span class="__presentation-speaker-institute" v-if="speaker.Institute && cardProps.cardConfig.posterPresentationCard.showAuthorInstitute">
                        {{speaker.Institute}}</span><span
                            class="__presentation-speaker-city"
                            v-if="cardProps.cardConfig.posterPresentationCard.showAuthorCity"
                            v-html="speaker.City ? ` ${openBracket}${speaker.City}${speaker.Country && cardProps.cardConfig.posterPresentationCard.showAuthorCountry ? ', ': closeBracket}`:''"
                        />
                        <span
                            class="__presentation-speaker-country"
                            v-if="cardProps.cardConfig.posterPresentationCard.showAuthorCountry"
                            v-html="speaker.Country ? `${speaker.City && cardProps.cardConfig.posterPresentationCard.showAuthorCity ? '': ' '+openBracket}${speaker.Country}${closeBracket}`:''"
                        />
                      </div>
                    </div>
                    <div
                        class="__presentation-name pag-body-text board-number-section"
                        v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.posterPresentationCard && cardProps.cardConfig.posterPresentationCard.showPosterPresentationSort && presentation.Sort && boardNumber"

                    >
                      <span>{{ $te("VMX.Poster_sort_label") ? $t("VMX.Poster_sort_label") :'Board Number:'  }} {{presentation.Sort}}</span>
                    </div>
                    <div
                        class="__presentation-name pag-body-text"
                        v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.posterPresentationCard && cardProps.cardConfig.posterPresentationCard.showSessionTitle && presentation.Text"
                        v-html="presentation.SessionTitle"
                    />
                    <div
                        class="__presentation-tags"
                        v-if="cardProps && cardProps.cardConfig && cardProps.cardConfig.posterPresentationCard && cardProps.cardConfig.posterPresentationCard.showPresentationTags && presentation.PresentationTags"
                    >
                      <span
                          class="__tags pag-default-btn-inverse-sm"
                          v-for="(tags, idx) in presentation.PresentationTags"
                          :key="idx"
                          v-html="tags"
                      />
                    </div>
                    <div
                        class="__presentation-keywords"
                        v-if="cardProps.cardConfig.posterPresentationCard.showKeywords"
                    >
                      <span
                          class="__tags pag-default-btn-inverse-sm"
                          v-for="(tag, key) in presentation.Keywords"
                          :key="key"
                      >
                        {{ tag }}
                      </span>
                    </div>
                  </template>
                </div>
                <div class="__card-presentation-right-side">
                  <div 
                    v-if="contentList === 'Detail' && presentation.UseSessionRecordingV2 && content === 'Session'"
                    :class="[presentationListView ? '__session-recording-btn-container' : 'list__session-recording-btn-container']"
                  > 
                    <button
                      class="__jump-to-presentation"
                      @click.stop="jumpToSessionRecording()"
                    >
                      <font-awesome-icon :icon="['fas', 'play']" />
                      {{ $te("VMX.jump_to_presentation_btn") ? $t("VMX.jump_to_presentation_btn") : 'Watch now' }}
                    </button>
                  </div>
                  <template
                      v-if="
                      cardProps.cardConfig.posterPresentationCard.showTime &&
                        (!presentation.IsLiveSession && !liveInformation)||
                        (liveInformation &&
                          !presentation.IsLiveSession &&
                          !liveInformation.IsLiveSession)
                    "
                  >
                    <div
                        :class="['__card-time-display', posterPresentationListView ? 'single' : '']"
                        v-if="cardProps.cardConfig.posterPresentationCard.showTime && presentation.StartDateTime"
                    >
                      <span>
                        <span v-if="useEposterDate">{{`Online release: `}}</span>{{ `${formatOndemandDate(presentation.StartDateTime)}` }}
                      </span>
                      <span v-if="!useEposterDate">
                        {{ `${ $t('AppTranslations.AvailableFrom') } ${ formatOndemandTimePresentation(presentation.StartDateTime)} ${timeZoneName(presentation.StartDateTime)}` }}
                      </span>
                      <span v-if="useEposterDate">
                        {{ `Onsite display: ${ presentation.EPosterDate } ${ timeZoneName(presentation.StartDateTime)}` }}
                      </span>
                    </div>
                  </template>
                  <template v-else-if="cardProps.cardConfig.posterPresentationCard.showTime">
                    <div
                        :class="['__card-time-display', posterPresentationListView ? 'single' : '']"
                        v-if="cardProps.cardConfig.posterPresentationCard.showTime && presentation.StartDateTime && presentation.EndDateTime"
                    >
                      <span>
                        {{ `${formatDateTime(presentation.StartDateTime)}` }}
                      </span>
          
                       <span v-if="useEposterDate">
                        {{ `Onsite display: ${ presentation.EPosterDate } ${ timeZoneName(presentation.StartDateTime)}` }}
                      </span>
                      <span v-else>
                        {{ `${ formatTime(presentation.StartDateTime, presentation.EndDateTime) } ${ timeZoneName(presentation.StartDateTime)}` }}
                      </span>
                    </div>
                    <template v-if="false">
                      <span class="my-programme__card-countdown">
                        <template v-if="countdown === 'LIVE'">
                          <font-awesome-icon :icon="['fas', 'circle']" />
                        </template>
                        <template v-else>
                          <font-awesome-icon :icon="['fas', 'clock']" />
                        </template>
                        {{ countdown }}
                      </span>
                    </template>
                  </template>
                  <span
                      v-if="cardProps.cardConfig.posterPresentationCard.showViews && presentation.EnableViewCounter"
                      :class="['__card-views', posterPresentationListView ? 'single' : '']"
                  >
                    <font-awesome-icon :icon="['fas', 'eye']" />
                    <span>{{ presentation.ViewCount }}
                      {{ $t("AppTranslations.ViewsLabel") }}</span>
                  </span>
                  <div
                      class="__card-rating"
                      v-if="cardProps.cardConfig.posterPresentationCard.showRating && presentation.EnableRating && user"
                  >
                    <rating
                    :id="presentation.PresentationId.toString()"
                  :user-id="user ? user.UserId : null"
                  :myrating="myRatingPresentation ? myRatingPresentation : presentation.RatingAvg"
                  :readonly="false"
                  :size="20"
                  :active-color="activeColor"
                  :inactive-color="inactiveColor"
                  :border-color="activeColor"
                  rating-context="Presentation"
                />
                  </div>
                  <div :class="['__card-content-child-actions', posterPresentationListView ? 'single' : '']">
                    <div :class="['__card-presentation-actions', posterPresentationListView ? 'single' : '']">
                      <template v-if="!isSpeaker && (user || enableLoginModal)">
                        <button
                            class="__add-to-favourite pag-default-btn-inverse-sm"
                            v-if="cardProps.cardConfig.posterPresentationCard.showFavoritesToggle"
                            @click.stop="
                            user ? 
                            toggleFavorites(
                              presentation.PresentationId,
                              'Presentation',
                              presentation.IsPoster
                            )
                            : showLoginModal()
                          "
                        >
                          <template
                              v-if="isFavorite(presentation.PresentationId, 'Presentation')"
                          >
                            <font-awesome-icon :icon="['fas', 'star']" />
                            {{ $t("VMX.my_programme_remove_from_favourites") }}
                          </template>
                          <template v-else>
                            <font-awesome-icon :icon="['far', 'star']" />
                            {{ $t("VMX.my_programme_add_to_favourites") }}
                          </template>
                        </button>
                      </template>
                      <button
                          class="__download-calendar pag-default-btn-inverse-sm"
                          v-if="cardProps.cardConfig.posterPresentationCard.showCalendarDownload"
                          @click.stop="
                          downloadCal(
                            presentation.PresentationId,
                            'Presentation',
                            presentation.IsPoster,
                            presentation
                          )
                        "
                      >
                        <font-awesome-icon :icon="['fas', 'calendar']" />
                        {{ $t("VMX.my_programme_save_calender") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-if="abstract">
      <div
          class="abstract__card"
          @click="abstract.ExternalAbstractUrl ? abstractIframeUrl(abstract.ExternalAbstractUrl) : downloadAbstract(abstract.HtmlFileUrl || abstract.PdfFileUrl, abstract.Id)"
      >
        <div class="__card_content">
          <span
              class="__abstract-id"
              v-if="cardProps.cardConfig.abstractCard.showId"
          >
            <template>
              {{ $t("VMX.my_programme_abstract_id") }}
              {{ abstract.Number }}
            </template>
          </span>
          <span
              class="__abstract-id"
              v-if="cardProps.cardConfig.abstractCard.showShort && abstract.Short"
          >
            <template>
              {{ $t("VMX.my_programme_abstract_id") }}
              {{ abstract.Short }}
            </template>
          </span>
          <span
              class="__abstract-title pag-body-text"
              v-if="cardProps.cardConfig.abstractCard.showTitle && abstract.TitleRaw"
              v-html="abstract.TitleRaw"
          />
          <div
              v-if="
              cardProps.cardConfig.abstractCard.showCategory && abstract.Category ||
                cardProps.cardConfig.abstractCard.showType && abstract.TypeName
            "
          >
            <span
                class="__abstract-category pag-default-btn-inverse-sm"
                v-if="cardProps.cardConfig.abstractCard.showCategory && abstract.Category"
                v-html="abstract.Category"
            />
            <span
                class="__abstract-typename pag-default-btn-inverse-sm"
                v-if="cardProps.cardConfig.abstractCard.showType && abstract.TypeName"
                v-html="abstract.TypeName"
            />
          </div>

          <span
              class="__abstract-presentername"
              v-if="cardProps.cardConfig.abstractCard.showPresenter && abstract.PresenterName"
              v-html="abstract.PresenterName"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import dayjs from 'dayjs'
import rating from 'm-anage.com.vmx-components/src/Rating'
import myProgrammeMixins from 'm-anage.com.vmx-components/src/mixins/myProgrammeMixins'
import pageStateMixins from 'm-anage.com.vmx-components/src/mixins/pageStateMixins'
import timezone from 'dayjs/plugin/timezone' // load on demand
import nameMixins from 'm-anage.com.vmx-components/src/mixins/nameMixins'
import programApi from '~/api/program'
import utils from '../../utilities'
import trackingApi from '~/api/tracking'

const isBetween = require('dayjs/plugin/isBetween')

dayjs.extend(isBetween)
dayjs.extend(timezone)

export default {
  name: 'ProgrammeListCard',
  components: { rating },
  mixins: [
    myProgrammeMixins,
    pageStateMixins,
    nameMixins,
  ],
  props: {
    isSpeaker: {
      type: Boolean,
      default: false,
    },
    contentList: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    isChair: {
      type: Boolean,
      default: false,
    },
    presentation: {
      type: Object,
      default() {
        return null
      },
    },
    session: {
      type: Object,
      default() {
        return null
      },
    },
    liveInformation: {
      type: Object,
      default() {
        return null
      },
    },
    abstract: {
      type: Object,
      default() {
        return null
      },
    },
    cardProps: {
      type: Object,
      default() {
        return {
          cardConfig: {
            sessionCard: {
              showId: true,
              showTitle: true,
              showTime: true,
              showCountdown: true,
              showSessionGroup: true,
              showFavoritesToggle: true,
              showRating: true,
              showCalendarDownload: true,
              showRoom: true,
              showIconsOnly: true,
              showAuthorInstitute: true,
            },
            posterCard: {
              showId: true,
              showTitle: true,
              showTime: true,
              showCountdown: true,
              showSessionGroup: true,
              showFavoritesToggle: true,
              showRating: true,
              showCalendarDownload: true,
              showViews: true,
              showRoom: true,
              showIconsOnly: true,
              showAuthorInstitute: true,
            },
            presentationCard: {
              showId: true,
              showTitle: true,
              showTime: true,
              showSessionTitle: true,
              showWebcastImage: true,
              showAuthors: true,
              showAuthorCity: true,
              showAuthorCountry: true,
              showFavoritesToggle: true,
              showRating: true,
              showKeywords: true,
              showCalendarDownload: true,
              showViews: true,
              showRoom: true,
              showAuthorInstitute: true,
            },
            posterPresentationCard: {
              showId: true,
              showTitle: true,
              showSessionTitle: true,
              showTime: true,
              showWebcastImage: true,
              showAuthors: true,
              showAuthorCity: true,
              showAuthorCountry: true,
              showFavoritesToggle: true,
              showRating: true,
              showCalendarDownload: true,
              showViews: true,
              showRoom: true,
              showPosterPresentationSort: false,
              showAuthorInstitute: true,
            },
            abstractCard: {
              showId: true,
              showShort: true,
              showTitle: true,
              showPresenter: true,
              showCategory: true,
              showType: true,
            },
          },
        }
      },
    },
    presentationListView: {
      type: Boolean,
      default: false,
    },
    sessionListView: {
      type: Boolean,
      default: false,
    },
    posterListView: {
      type: Boolean,
      default: false,
    },
    posterPresentationListView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      author: null, 
      authors: [],
      coAuthors: [],
      myRating: null,
      myRatingPresentation: null,
      assignedAbstract: null,
      sessionGroup: [],
      boardNumber: false,
    }
  },
  async mounted() {
    if (this.session) {
      // this.getSessionRating(this.session.SessionId)
      this.getSessionTags()
      this.selectTemplateViaTime(this.session.SessionId, this.session.StartDateTime, this.session.EndDateTime)
    }

    if (this.presentation) {
       if(!this.solr) {
        await this.loadAbstracts()
      }
      this.selectTemplateViaTime(this.presentation.SessionId, this.presentation.SessionStart, this.presentation.SessionEnd)
      this.author = this.speakers.filter((author) => this.presentation.Speakers?.some(
          (speaker) => author.UserId === speaker.UserId && speaker.key === 'Speaker',
      ))
      this.coAuthors = this.speakers.filter((author) => this.presentation.Speakers?.some(
          (speaker) => author.UserId === speaker.UserId && speaker.key === 'CoSpeaker',
      ))
      this.authors = [...this.author, ...this.coAuthors]
      if (this.abstracts) {
        this.assignedAbstract = this.abstracts.find((abstract) => abstract.Id === this.presentation.AbstractId)
      }

      if(this.presentation.SessionGroups) {
        this.boardNumber = !this.presentation.SessionGroups.some((sg) => {
          const selector = "GroupName" in sg ? "GroupName" : "Name"
          return sg[selector].toLowerCase().includes('oral presentation')
        })
      }

    }
    if (this.abstract) {
      this.activateComponentForAbstract()
    }
  },
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
      speakers: 'pagAuthors/authors',
      inVMX: 'instancesState/getInVMX',
      isAppContainer: 'instancesState/getIsAppContainer',
      abstracts: 'pagAbstracts/abstracts',
      user: 'user/user',
      jumptimes: 'sessionRecordingData/getJumptimes',
      solr: 'instancesState/getSolrPAG'
    }),
    thumbnailSrc() {
      if(this.showDemoVersion) {
        return this.presentation.Thumbnail
      }
      if (this.template) {
        if (!this.presentation.IsOnDemandSession) return this.template.noWebcastPreviewThumbnail
        if (!this.presentation.WebcastEnabled) return this.template.noWebcastPreviewThumbnail
        if (this.presentation.Suppresswebcast) {
          return this.template.suppressedWebcastThumbnail ? this.template.suppressedWebcastThumbnail : this.template.noWebcastPreviewThumbnail
        }
        if (!this.presentation.WebCastPermission) {
          return this.template.noPermissionWebcastThumbnail ? this.template.noPermissionWebcastThumbnail : this.template.noWebcastPreviewThumbnail
        }
        if (this.checkOndemandAvailability()) {
          return this.presentation.Thumbnail ? this.presentation.Thumbnail : this.template.previewThumbnail
        }
        return this.template.previewThumbnail
      }

      return null
    },
    industryThumnailSrc() {
      const c = this.configForKey('industry_config').config.symposiaPage
      if(this.session.ImageThumbPath) return this.session.ImageThumbPath

      else {
        return c?.symposiaCardThumbnail
          ? c.symposiaCardThumbnail
          : 'https://distribute.m-anage.com/from.storage?filecore=IbVLAgufffTUu_nFfF5Thg'
      }
    },
    showDemoVersion() {
      const c = this.configForKey('app_config').configV2
      return 'showDemoVersion' in c?.defaultV2
          ? c.defaultV2.showDemoVersion
          : false
    },
    defaultProfileError() {
      const c = this.configForKey('app_config').configV2
      return 'defaultProfileError' in c?.defaultV2
          ? c.defaultV2.defaultProfileError
          : 'https://distribute.m-anage.com/from.storage?filecore=zaqTlY6sI7XlwlhhjtkCsg'
    },
    defaultThumbnailError() {
      const c = this.configForKey('app_config').configV2
      return 'defaultThumbnailError' in c?.defaultV2
          ? c.defaultV2.defaultThumbnailError
          : 'https://distribute.m-anage.com/from.storage?filecore=Lb5hILLv5itSIgSySRNmmQ'
    },
    showThumbnailOnIndustrySymposia() {
      const c = this.configForKey('app_config').configV2
      return c?.defaultV2?.showThumbnailOnIndustrySymposia
          ? c.defaultV2.showThumbnailOnIndustrySymposia
          : false
    },
    showAuthorTitle() {
      const c = this.configForKey('app_config').configV2
      return c?.defaultV2?.showAuthorTitle
          ? c.defaultV2.showAuthorTitle
          : false
    },
    showAuthorTitleProfession() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.showAuthorTitleProfession
        ? c.defaultV2.showAuthorTitleProfession
        : false
    },
    showSessionShortInsteadOfId () {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.showSessionShortInsteadOfId
        ? c.defaultV2.showSessionShortInsteadOfId
        : false
    },
    enableCondensedCards () {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.enableCondensedCards
        ? c.defaultV2.enableCondensedCards
        : false
    },
    titleCondition() {
      return this.showAuthorTitleProfession ? false : this.showAuthorTitle
    },
    openBracket() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.openBracket
        ? c.defaultV2.openBracket
        : '('
    },
    closeBracket() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.closeBracket
        ? c.defaultV2.closeBracket
        : ')'
    },
    showAuthorImageInList() {
      const c = this.configForKey('app_config').configV2
      return 'showAuthorImageInList' in c?.defaultV2
          ? c.defaultV2.showAuthorImageInList
          : false
    },
    detailViewCheck() {
      return window.location.href.includes('presentation') || window.location.href.includes('session')
    },
    showOnDemandTime() {
      const c = this.configForKey('app_config').configV2
      return 'showOnDemandTime' in c?.defaultV2
          ? c.defaultV2.showOnDemandTime
          : true
    },
    forceOndemandTime() {
      const c = this.configForKey('app_config').configV2
      return 'forceOndemandTime' in c?.defaultV2
          ? c.defaultV2.forceOndemandTime
          : false
    },
    openAbstractsInsteadOfPresentations() {
      const c = this.configForKey('app_config').configV2
      if (c?.defaultV2?.openAbstractsInsteadOfPresentations) {
        return c.defaultV2.openAbstractsInsteadOfPresentations.includes(this.presentation.SessionTypeName)
      }
      return false
    },
    showHybridMode() {
      const c = this.configForKey('app_config').configV2
      if (c?.defaultV2?.showHybridMode === true) {
        return true
      }
      return false
    },
    useEposterDate() {
      const c = this.configForKey('app_config').configV2
      return 'useEposterDate' in c?.defaultV2
          ? c.defaultV2.useEposterDate
          : false
    },
    sessionCardColor() {
      const c = this.config('app_config').configV2.defaultV2
      return c.SessionColorProperty ? c.SessionColorProperty : 'Color'
    },
    presentationCardColor() {
      const c = this.config('app_config').configV2.defaultV2
      return c.PresentationColorProperty ? c.PresentationColorProperty : 'None'
    },
  
    activeColor() {
      return 'var(--primary-industry)'
    },
    inactiveColor() {
      return 'var(--primary-industry-inactive-rating)'
    },
    countdown() {
      const eventTimezone = utils.eventTimezone()
      const selectedTimezone = localStorage.getItem('selectedTimezone')

      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)
      let startDate
      let endDate
      if (this.session) {
        if (selectedTimezone === eventTimezone) {
          startDate = dayjs(this.session.StartDateTime).tz(eventTimezone, true)
          endDate = dayjs(this.session.EndDateTime).tz(eventTimezone, true)
        } else {
          startDate = dayjs(this.session.StartDateTime).tz(eventTimezone)
          endDate = dayjs(this.session.EndDateTime).tz(eventTimezone)
        }
      }

      if (this.presentation) {
        startDate = dayjs(this.presentation.StartDateTime).tz(eventTimezone, true)
        endDate = dayjs(this.presentation.EndDateTime).tz(eventTimezone, true)
      }
      const startDateDiff = startDate.diff(nowDate, 'minutes')
      if (startDateDiff > 0 && startDateDiff <= 60) {
        return `in ${startDate.diff(this.dateNow, 'minutes')} min`
      }
      if (nowDate.isBetween(startDate, endDate)) {
        return 'LIVE'
      }
      return null
    },
    placeHolder() {
      const [c] = this.configForKey('app_config').config
      return c.placeholderPlayerUrl ? c.placeholderPlayerUrl : ''
    },
    noWebcastPlaceHolder() {
      const [c] = this.configForKey('app_config').config
      return c.placeholderUrlNoPres ? c.placeholderUrlNoPres : ''
    },
    cardOpacity() {
      const c = this.config('app_config').configV2.defaultV2
      return c.cardOpacity?.sessionCardList ? c.cardOpacity.sessionCardList : 0.2
    },
    isStandalone() {
      return localStorage.getItem('layer') === 'Standalone'
    },
    hideThumbnailInStandalone() {
      const c = this.configForKey('app_config').configV2
      return this.isStandalone && 'hideThumbnailInStandalone' in c?.defaultV2 ? c.defaultV2.hideThumbnailInStandalone : false
    },
    enableLoginModal() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.enableLoginModal
        ? c.defaultV2.enableLoginModal
        : false
    },
    enableDisplayNameWithInitials() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.enableDisplayNameWithInitials
        ? c.defaultV2.enableDisplayNameWithInitials
        : false
    },
  },
  methods: {
    ...mapActions({
      loadAbstracts: 'pagAbstracts/loadAbstracts',
    }),
    showWatchNow(params) {
      if(this.jumptimes) {
        return this.jumptimes.some(item => item.Id === params)
      } else {
        return false
      }
    },
    jumpToSessionRecording() {
      trackingApi.trackCustomAction('vmx-jump-to-session-recording', this.presentation.PresentationId)

      window.mPlayer.jumpToPresentation(this.presentation.PresentationId)
      window.mPlayer.play()
      document.getElementById('pag-session-recording').scrollIntoView();
    },
    checkIfIndustrySymposia() {
      if(window.location.pathname.includes('industrySymposia')) return true
    },
    checkOndemandAvailability() {
      if (!this.presentation.OnDemandAvailability) {
        return false
      }

      const eventTimezone = utils.eventTimezone()
      const demandDate = dayjs(dayjs(this.presentation.OnDemandAvailability).tz(eventTimezone, true))

      dayjs.tz.setDefault(eventTimezone)

      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)

      if (this.$store.getters['instancesState/getSuperUser']) return true
      return nowDate.isAfter(demandDate)
    },
    hexToRgbA(hex) {
      if (hex) {
        let c
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
          c = hex.substring(1)
              .split('')
          if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
          }
          c = `0x${c.join('')}`
          return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')}, ${this.cardOpacity})`
        }
        throw new Error('Bad Hex')
      }
      return ''
    },
    formatOndemandTime(value) {
    const programConfig = this.dateAppConfig.config[0].programme[0]
    const eventTimezone = utils.eventTimezone()
    const selectedTz = localStorage.getItem('selectedTimezone') ? localStorage.getItem('selectedTimezone') : 'Europe/Berlin'
    if (programConfig.dateformatTime && value) {
        if (this.solr) {
            return this.camelize(dayjs(value).format(programConfig.dateformatTime))
        } else {
            if (eventTimezone === selectedTz) {
                return `${dayjs(value).format(programConfig.dateformatTime)}`
            }
            return this.camelize(dayjs(dayjs(value).format(programConfig.dateformatTime)))
        }
    }
    if (value && !programConfig.dateformatTime) {
        if (this.solr) {
            return this.camelize(dayjs(value).format(utils.timeFormat()))
        } else {
            if (eventTimezone === selectedTz) {
                return this.camelize(dayjs(value).format(utils.timeFormat()))
            }
            return this.camelize(dayjs(dayjs(value)).format(utils.timeFormat()))
        }
    }
    return null
    },
    formatOndemandTimePresentation(value) {
    const programConfig = this.dateAppConfig.config[0].programme[0]
    const eventTimezone = utils.eventTimezone()
    const selectedTz = localStorage.getItem('selectedTimezone') ? localStorage.getItem('selectedTimezone') : 'Europe/Berlin'
    if (programConfig.dateformatTime && value) {
        if (this.solr) {
            return `${dayjs(value).format(programConfig.dateformatTime)}`
        } else {
            if (eventTimezone === selectedTz) {
                return `${dayjs(value).format(programConfig.dateformatTime)}`
            }
            return `${dayjs(dayjs(value).tz(eventTimezone, true)).tz(this.selectedTimezone).format(programConfig.dateformatTime)}`
        }
    }
    if (value && !programConfig.dateformatTime) {
        if (this.solr) {
            return `${dayjs(value).format(utils.timeFormat())}`
        } else {
            if (eventTimezone === selectedTz) {
                return `${dayjs(value).format(utils.timeFormat())}`
            }
            return `${dayjs(dayjs(value)).tz(eventTimezone, true).tz(this.selectedTimezone).format(utils.timeFormat())}`
        }
    }
    return null
    },
    camelize(str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase())).replace(/\s+/g, '')
    },
    formatOndemandDate(value) {
      const programConfig = this.dateAppConfig.config[0].programme[0]
      if (programConfig.dateformat && value) {
        return dayjs(String(value)).format(programConfig.dateformat)
      }
      if (value && !programConfig.dateformat) {
        return dayjs(value).format('dddd, d MMM YYYY')
      }
      return null
    },
    async getSessionRating(id) {
      const note = await programApi.getSessionRating(id.toString())
      this.myRating = note.RatingValue
    },
    async getPresentationRating(id, userId) {
      const note = await programApi.getPresentationRating(id.toString(), userId)
      this.myRatingPresentation = note.RatingValue
    },
    sortAlpha(args) {      
      return args.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
    },
    getSessionTags() {
      let sessionTags = []
      let sessionGroups = this.session ? this.session.SessionGroups : null
      if (sessionGroups) {
        for (const i in sessionGroups) {
          if (sessionGroups[i].Name) {
            sessionTags.push(sessionGroups[i].Name)
          }
        }      
        this.sessionGroup = sessionTags.length > 1 ? this.sortAlpha(sessionTags).sort(function (a, b) {return a - b}) : sessionTags
      }
      return
    },  
    showLoginModal(){
      this.$root.$emit('showLoginModal')
    }
  },
}
</script>
<style lang="scss" scoped>
.pag-list-card {
  cursor: pointer;

  .session__card,
  .poster__card {
    height: 100%;
    padding: 1.25rem;
    position: relative;

    .__symposia-thumbnail-image {
    width: 100%;
    aspect-ratio: 16/9;
    object-fit: cover;
  }
    .__card-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;

      .__chair-information {
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--pag-button-background);
        color: #fff;
        padding: .125rem .25rem;
        border-bottom-left-radius: .5rem;
      }
      .__card-content-child {
        display: flex;
        gap: calc(var(--pag-box-gap) / 2);

        &:not(.single) {
          flex-direction: column;
          @media (max-width: 600px) {
            flex-direction: column;
          }
          @media (min-width: 768px) {
            flex-direction: column;
          }
        }

        &.single {
          @media (max-width: 768px) {
            flex-direction: column;
          }
        }
        .__card-session-info-left {
          display: flex;
          flex-direction: column;
          gap: calc(var(--pag-box-gap) / 2);
          .__session-number {
          }

          @media (max-width: 767px) {
            .condensed .__session-number {
              display: none;
            }
          }

          .__session-name {
            font-weight: bold;
          }

          .__session-room {
            display: flex;
            align-items: center;
            gap: 0.25rem;
          }
          .__session-room-svg {
            display: flex;
            align-items: flex-end;
          }
          .__session-room > span {
            font-weight: bold;
            color: var(--pag-button-background);
          }
          .__session-room > i {
            margin-right: 5px;
          }

          .__session-type {
            font-weight: 700;
          }
          @media (max-width: 767px) {
            .condensed .__session-type {
               display: none;
              }
            }

          .__session-tags,
          .__session-groups {
            display: flex;
            gap: calc(var(--pag-box-gap) / 2);
            flex-wrap: wrap;
            .__tags {
              background: none;
              display: inline-block;
              line-height: 1.5;
              text-align: center;
              vertical-align: middle;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .__tags:hover {
              white-space: normal;
              overflow: unset;
            }
            > span.__tags {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 50ch;
            }
          }

          @media (max-width: 767px) {
            .condensed .__session-tags {
               display: none;
              }
            }
        }
        .__card-session-info-right {
          display: flex;
          flex-direction: column;
          gap: calc(var(--pag-box-gap) / 4);
          justify-content: space-between;

          .__top-right-container {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            &:not(.single) {
              justify-content: flex-start;
            }
            .__card-cd-live-indicator {
              color: #e52229;
            }
            .__card-time-display {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              &.single {
                align-items: flex-end;
              }
              &:not(.single) {
                align-items: flex-start;
              }
            }
            @media (max-width: 768px) {
              .__card-time-display {
              &.single {
                align-items: flex-start;
              }
            }
            }
            @media (max-width: 768px) {
              .condensed.__card-time-display {
                display: flex;
                flex-direction: row !important;
                gap: .25rem;       
            }
            }
          }
          @media (max-width: 768px) {
            .__top-right-container.condensed {
              display: flex;
              flex-direction: row !important;
              gap: .25rem;
          }     
        }
          .__bottom-right-container {
            display: flex;
            gap: 0.25rem;
            align-items: center;
            justify-content: flex-end;
            flex-wrap: wrap;
            &:not(.single) {
              justify-content: flex-start;
            }
            .__card-views {
            }
            .__card-rating {
            }

            .pag-scheduler__session-infos-live > *,
            .pag-scheduler__session-infos-ondemand > *,
            .pag-scheduler__session-infos-highlight > * {
              padding: 0.06125rem 0.125rem;
              text-transform: uppercase;
              font-weight: bold;
            }
          }

          .pag-scheduler__session-infos-highlight {
                text-transform: uppercase;
                background: #fff;
                padding: 0.06125rem 0.125rem;
                width: fit-content;
          }

          &:not(.single) {
            @media (max-width: 600px) {
              align-items: flex-start;

              .__top-right-container {
                justify-content: space-between;
                align-items: flex-start;
              }
            }

            @media (max-width: 768px) {
              align-items: flex-start;
              .__top-right-container {
                justify-content: space-between;
                align-items: flex-start;
              }
            }
          }

          &.single {
            @media (max-width: 768px) {
              align-items: flex-start;

              .__top-right-container {
                justify-content: space-between;
                align-items: flex-start;
              }
            }
          }
        }
        .__card-session-actions {
          display: flex;
          gap: calc(var(--pag-box-gap) / 4);
          flex-wrap: wrap;
          justify-content: flex-end;
          button {
            &.__add-to-favourite,
            &.__download-calendar {
              background: none;
              cursor: pointer;
              text-align: left;

              svg {
                margin-right: 5px;
              }
            }
          }
          &:not(.single) {
            justify-content: flex-start;
          }
        }
        @media (max-width: 768px) {
          .__card-session-actions {
            justify-content: flex-start;
          }

          .condensed.__card-session-actions {
            display: grid; 
            grid-template-columns: repeat(2, 1fr); 
            gap: calc(var(--pag-box-gap) / 4); 
          }

          .condensed.__card-session-actions button {
            justify-content: center; 
          }

          .condensed.__card-session-actions button span {
            display: none; 
          }

          .condensed.__card-session-actions button svg {
            margin-right: 0; 
          }
        }
      }
      .__card-content-child:nth-child(1) {
        justify-content: space-between;
      }
      .__card-content-child:nth-child(2) {
        justify-content: flex-end;
        margin-top: 1.25rem;
      }
    }
  }

  .presentation__card,
  .poster-presentation__card {

    .__content-profile-image {
      object-fit: cover;
      height: 90px;
      width: 90px;
      min-width: 90px;
      max-width: 90px;
      border-radius: 50%;
      border: solid 3px var(--pag-primary);
    }
    position: relative;
    height: 100%;
    padding: 1.25rem;
    background-color: #f6f6f6;
    .__card_content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      .__speaker-information {
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--primary);
        color: #fff;
        padding: .125rem .25rem;
        border-bottom-left-radius: .5rem;
      }
      .__card-content-child {
        display: flex;
        gap: calc(var(--pag-box-gap) / 2);

        &:not(.single) {
          flex-direction: column;
          @media (max-width: 576px) {
            flex-direction: column;
          }
          @media (min-width: 768px) {
            flex-direction: column;
          }
        }

        &.single {
          flex-direction: row;

          @media (max-width: 768px) {
            flex-direction: column;
          }
        }

        .__card-presentation-info-left {
          &:not(.single) {
            display: none;
            @media (max-width: 576px) {
              display: none;
            }
            @media (min-width: 768px) {
              display: none;
            }
          }
          &.single {
            display: flex;
            align-items: center;
            @media (max-width: 768px) {
              display: none;
            }
          }

          .__card_thumbnail {
            width: 140px;
          }
        }

        .__card-presentation-info-right {
          display: flex;
          width: 100%;
          justify-content: space-between;
          gap: calc(var(--pag-box-gap) / 2);

          .__card-presentation-left-side {
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 0 1 70%;

            .__presentation-number {
            }
            .__presentation-name {
              font-weight: 700;
            }
            .__presentation-highlight {
              text-transform: uppercase;
            }
            .__presentation-speaker {
              .__presentation-speaker-name {
                font-weight: 700;
              }
              .__presentation-speaker-institute,
              .__presentation-speaker-city,
              .__presentation-speaker-country {
              }
            }
            .__presentation-highlight {
                text-transform: uppercase;
                background: #fff;
                padding: 0.06125rem 0.125rem;
                width: fit-content;
              }
            .__presentation-speaker:not(:last-child):after {
              content: ", ";
            }

            .__presentation-keywords,
            .__presentation-tags {
              display: flex;
              gap: calc(var(--pag-box-gap) / 2);
              flex-wrap: wrap;
            }
          }
          .__card-presentation-right-side {
            flex: 0 1 30%;
            display: flex;
            flex-direction: column;
            gap: calc(var(--pag-box-gap) / 4);
            justify-content: space-between;

            .__session-recording-btn-container {
              display: flex;
              justify-content: flex-end;
              @media (max-width: 768px) {
                justify-content: flex-start;
              }
            }
            .list__session-recording-btn-container {
              display: flex;
              justify-content: flex-start;
            }

            button {
              &.__jump-to-presentation {
                display: flex;
                align-items: center;
                line-height: 1.5;
                text-align: center;
                vertical-align: middle;
                font-weight: 400;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                border: none;
                cursor: pointer;

                svg {
                  margin-right: 5px;
                }
              }
            }


            .__card-time-display {
              display: flex;
              flex-direction: column;
              align-items: flex-start;

              &:not(.single) {
                align-items: flex-start;
              }

              @media (min-width:768px) {
                &.single {
                  align-items: flex-end;
                }
              }

            }
            .__card-views {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              span {
                margin-left: 5px;
              }
               
              @media (max-width:768px) {
              justify-content: flex-start;

                &.single {
                   justify-content: flex-start;
                }
              }
            }
            .__card-rating {
              display: flex;
              justify-content: flex-end;

              @media (max-width:768px) {
              justify-content: flex-start;

                &.single {
                   justify-content: flex-start;
                }
              }
            }
          }

          &:not(.single) {
            flex-direction: column;
            align-items: flex-start;

            @media (max-width: 600px) {
              flex-direction: column;
              .__card-presentation-right-side {
                .__card-time-display {
                  align-items: flex-start;
                }

                .__card-views {
                  display: block;
                }
              }
            }

            @media (min-width: 768px) {
              flex-direction: column;
              .__card-presentation-right-side {
                .__card-time-display {
                  align-items: flex-start;
                }
                .__card-views {
                  display: block;
                }
              }
            }
          }

          &.single {
            @media (max-width: 768px) {
              flex-direction: column;
              .__card-presentation-right-side {
                .__card-time-display {
                  align-items: flex-start;
                }
              }
            }
          }
          .presentation-card__speaker--hybridMode {
            border-radius: 60px;
            background: rgba($color: #444444, $alpha: 0.1);
            color: inherit;
            padding: 0.1rem 0.5rem;
            margin-left: 0.3rem;
          }
        }

        .__card-presentation-actions {
          display: flex;
          gap: calc(var(--pag-box-gap) / 4);
          flex-wrap: wrap;
          justify-content: flex-end;

          button {
            &.__add-to-favourite,
            &.__download-calendar {
              background: none;
              cursor: pointer;
              text-align: left;
              white-space: nowrap;
              svg {
                margin-right: 5px;
              }
            }
          }
          &:not(.single) {
            justify-content: flex-start;
          }

          @media (max-width: 768px) {
            justify-content: flex-start;
          }
        }

      }

      .__card-content-child:nth-child(2) {
        justify-content: flex-end;
      }
    }
  }

  .abstract__card {
    height: 100%;
    padding: 1.25rem;
    background-color: #f6f6f6;

    .__card_content {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;

      .__abstract-id {
      }
      .__abstract-title {
        font-weight: 700;
      }
      div {
        display: flex;
        gap: 0.25rem;
        .__abstract-typename,
        .__abstract-category {
          background: none;
          display: inline-block;
          line-height: 1.5;
          text-align: center;
          vertical-align: middle;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .__abstract-presentername {
        font-weight: 700;
      }
    }
  }
}

</style>